<template>
        <v-btn
                v-if="!currentUser"
                :color="color || 'primary'"
                text
                class="font-weight-light start-session"
                dark
                :disabled="loadingLogin"
                active-class="active-menu"
                @click="openLoginForm(false)">
                {{loadingLogin ? 'Ingresando... ' : 'Iniciar sesion'}}
            <v-icon v-if="!loadingLogin" class="ml-2" size="20px" dark>fa-sign-in-alt</v-icon>
            <v-progress-circular
                    class="ml-2"
                    v-if="loadingLogin"
                    indeterminate
                    color="primary"
                    size="20"
            ></v-progress-circular>
        </v-btn>

        <v-menu v-else  :class="{'hidden-sm-and-down': (hideOnMobile === true || typeof hideOnMobile == 'undefined')}">

          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" :color="color || 'primary'" text class="font-weight-light start-session" dark active-class="active-menu">
              <kimsa-avatar size="32px" :imageUrl="currentUser && currentUser.super ? require('@/assets/img/super.jpg') : currentUser.avatar"></kimsa-avatar>
            </v-btn>
          </template>



            <v-list>
                <v-list-item :to="{name: 'panel.user.info'}" >
                    <v-list-item-title>
                        <v-icon size="20" class="pr-1">account_circle</v-icon>
                        Mi cuenta
                    </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="logout" >
                    <v-list-item-title>
                        <v-icon size="17" class="pr-1">fa-sign-out-alt</v-icon>
                        Salir
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

</template>

<script>
    import KimsaAvatar from '@/components/common/KimsaAvatar'
    import {mapState, mapMutations} from 'vuex'
    import {ApiUtils} from "@/utils/ApiUtils";

    export default{
        props: ['color', 'hideOnMobile'],
        components: {KimsaAvatar},
        computed: {
              ...mapState(['loadingLogin', 'currentUser'])
        },
        methods: {
                ...mapMutations(['setLogoutVisibility', 'openLoginForm']),
            async logout() {
                ApiUtils.logout()
            }
        }
    }
</script>
